import colorPalette from '../color-palette';

const { background, text } = colorPalette;

export default {
  MuiTextField: {
    root: {
      '& input': {
        height: '100%',
        padding: 0,
        backgroundColor: background.textInput,
        boxSizing: 'border-box',
        color: text.primary,
        fontWeight: 700,
        '&::placeholder': {
          fontWeight: 400,
        },
        marginTop: '2px',
      },
      '& label': {
        zIndex: 1,
      },
    },
  },
};
